<template>
  <v-dialog
    width="700"
    persistent
    transition="slide-x-transition"
    v-model="getModalUpdatePass"
  >
    <v-card dark class="expande-horizontal wrap">
      <div class="expande-horizontal px-6 py-3">
        <v-btn dark @click="fechaModalUpdatePass" icon>
          <v-icon color="grey">
            mdi-chevron-left
          </v-icon>
        </v-btn>
        <span style="font-size: 17pt;" class="fonte white--text">
          Atualizar Senha
        </span>
        <div class="expande-horizontal"></div>
        <v-btn class="elevation-3" icon @click="fechaModalUpdatePass">
          <v-icon color="red darken-3">
            mdi-close
          </v-icon>
        </v-btn>
      </div>

      <div class="expande-horizontal wrap py-6 pb-0">
        <v-flex xs12>
          <v-form ref="form">
            <v-flex class="px-7" xs12>
              <span class="py-3 fonte" :style="`color: ${$theme.primary}`">
                Nova Senha
              </span>
              <v-text-field
                v-model="payload.nova_senha"
                :rules="[v=> !!v || 'preencha aqui']"
                dense
                solo-inverted
                flat
                :color="$theme.primary"
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-flex>
      </div>

      <div class="expande-horizontal">
        <v-btn large dark @click="validate" tile block color="green">
          <span class="fonte"> Salvar </span>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            payload: {}
        }
    },
  computed: {
    ...mapGetters(["getModalUpdatePass"])
  },
  methods: {
    ...mapActions(["updatePass", "fechaModalUpdatePass"]),
    validate() {
      if (this.$refs.form.validate()) {
        this.updatePass(this.payload);
      }
    }
  }
};
</script>
